import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/UserHeader.css';

const UserHeader = ({ isLoginScreen = false }) => {
  const navigate = useNavigate();

  return (
    <header className="user-header">
      <div className="user-header-container">
        <div
          className="user-header-logo"
          onClick={() => navigate('/standouts')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/images/logo1.png"
            alt="LegacyStat"
            className="user-header-logo-desktop"
          />
          {isLoginScreen ? (
            <img
              src="/assets/images/back-icon.png"
              alt="Back"
              className="user-header-back-icon"
              onClick={(e) => { e.stopPropagation(); navigate(-1); }}
            />
          ) : (
            <img
              src="/assets/images/logo4.png"
              alt="LegacyStat"
              className="user-header-logo-mobile"
            />
          )}
        </div>

        <nav className="user-header-nav">
          <a
            href="/about"
            className="user-header-nav-link"
            onClick={(e) => { e.preventDefault(); navigate('/about'); }}
          >
            About
          </a>
          <a
            href="/help-center"
            className="user-header-nav-link"
            onClick={(e) => { e.preventDefault(); navigate('/help-center'); }}
          >
            Help Center
          </a>
          <a
            href="/contact"
            className="user-header-nav-link"
            onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
          >
            Contact
          </a>
        </nav>

        <div className="user-header-auth">
          <button
            className="user-header-signup-btn"
            onClick={() => navigate('/standouts/signup')}
          >
            Sign up
          </button>
          <button
            className="user-header-login-btn"
            onClick={() => navigate('/standouts/login')}
          >
            Log In
          </button>
        </div>
      </div>
    </header>
  );
};

export default UserHeader;
